/** Shapes both APIs answer with (R0002 Notes/api-contract.md, "Shared shapes"). */
export type Paginated<TItem> = { items: Array<TItem>; total: number; page: number; pageSize: number };

export type TokenPair = { accessToken: string; refreshToken: string; accessTokenExpiresIn: number };

export type LicenceState = 'ACTIVE' | 'SUSPENDED' | 'AWAITING_PAYMENT' | 'EXPIRED' | 'NOT_YET_VALID';

export type LicenceLimits = {
  companies: number | null;
  subUsers: number | null;
  products: number | null;
  totalStock: number | null;
};

export type LicenceUsage = { companies: number; subUsers: number; products: number; totalStock: number };

export type SortDirection = 'asc' | 'desc';

export type InvoiceDocumentType = 'PROFORMA' | 'INVOICE';

export type InvoiceStatus = 'ISSUED' | 'PARTIALLY_PAID' | 'PAID' | 'CANCELLED';

/** A licence document as both APIs list it (R0006). Amounts are cents; dates `YYYY-MM-DD`. */
export type InvoiceSummary = {
  id: string;
  tenantId: string;
  tenantName: string;
  documentType: InvoiceDocumentType;
  number: string;
  variableSymbol: string;
  status: InvoiceStatus;
  overdue: boolean;
  issuedOn: string;
  dueOn: string;
  supplyDate: string | null;
  buyerName: string;
  totalMinor: number;
  paidMinor: number;
  currency: string;
};

/** E-shop platforms a link can be for (ADR-0008): each has its connector and its licence item. */
export type IntegrationPlatform = 'PRESTASHOP';

export const INTEGRATION_PLATFORMS: Array<IntegrationPlatform> = ['PRESTASHOP'];
